module.exports = __webpack_public_path__ + "static/media/icon-wb_cloud.f3013ab9.svg";